import { render } from "./AttachedEdit.vue?vue&type=template&id=2313cfe8"
import script from "./AttachedEdit.vue?vue&type=script&lang=js"
export * from "./AttachedEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__